var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-row",class:_vm.classes,on:{"click":_vm.actionClick}},[_vm._m(0),_c('span',{domProps:{"innerHTML":_vm._s(_vm.displayName)}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle"},[_c('div',{staticClass:"circle-mark"})])
}]

export { render, staticRenderFns }